import type { BdColorLightnessFactoryOptions} from './color-lightness';
import {BdColorLightnessFactory} from './color-lightness';
import type { BdColorSchemeFactoryOptions} from './color-scheme';
import {BdColorSchemeFactory} from './color-scheme';
import type {BdColorFactory} from './color-factory';
import {BdColorJudgementFactory} from "./color-judgement";
import type { BdColorCustomFactoryOptions} from "./color-custom";
import {BdColorCustomFactory} from "./color-custom";

export class BdColorFactoryFactory {

    public static fromObject(
      obj: BdColorLightnessFactoryOptions | BdColorSchemeFactoryOptions | BdColorCustomFactoryOptions
    ): BdColorFactory | null {
        let colorFactory: BdColorFactory = null;

        if(!obj.type) {
          return colorFactory;
        }

        switch (obj.type) {
          case 'lightness': {
            colorFactory = BdColorLightnessFactory.fromObject(obj as BdColorLightnessFactoryOptions);
            break;
          }
          case 'scheme': {
            colorFactory = BdColorSchemeFactory.fromObject(obj as BdColorSchemeFactoryOptions);
            break;
          }
          case 'judgement': {
            colorFactory = BdColorJudgementFactory.fromObject(obj);
            break;
          }
          default: {
            colorFactory = BdColorCustomFactory.fromObject(obj as BdColorCustomFactoryOptions)
          }
        }

        return colorFactory;
    }
}
